import React, { useEffect } from 'react';
import { SeoBar } from '../components/SeoBar';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { HeroSection } from './wire-types/HeroSection';
import { LinksBarSection } from './wire-types/LinksBarSection';
import { IntroSection } from './wire-types/IntroSection';
import { WirePropertiesSection } from './wire-types/WirePropertiesSection';
import { WireTypesSection } from './wire-types/WireTypesSection';
import { AutoRethreadingSection } from './wire-types/AutoRethreadingSection';
import { TroubleshootingSection } from './wire-types/TroubleshootingSection';
import { CertifiedWiresSection } from './wire-types/CertifiedWiresSection';
import { SmartWireSection } from './wire-types/SmartWireSection';
export function WireTypesPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen w-full bg-white flex flex-col" data-id="element-4482">
      <SeoBar data-id="element-4483" />
      <Header data-id="element-4484" />
      <main className="flex-grow" data-id="element-4485">
        <div className="w-full bg-gray-50 pb-20" data-id="element-4486">
          <HeroSection data-id="element-4487" />
          <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-12 space-y-12" data-id="element-4488">
            <LinksBarSection data-id="element-4489" />
            <IntroSection data-id="element-4490" />
            <WirePropertiesSection data-id="element-4491" />
            <WireTypesSection data-id="element-4492" />
            <AutoRethreadingSection data-id="element-4493" />
            <TroubleshootingSection data-id="element-4494" />
            <CertifiedWiresSection data-id="element-4495" />
            <SmartWireSection data-id="element-4496" />
            <LinksBarSection data-id="element-4497" />
          </div>
        </div>
      </main>
      <Footer data-id="element-4498" />
    </div>;
}